/*
 *  Ajax navigation url handler which navigates by opening a new window.
*/

rs.module("ui/framework/links/impersonation-url-handler",

    ["controls/components/event-banner"],

    function (eventBanner) {

        const windowName = 'impersonationWindow';

        //
        // Perform navigation
        //
        function navigate(data) {

            // Get a handle to an existing impersonation window
            var existingWindow = window.open('', windowName);

            // If there is an existing impersonation window, close it so the new window starts fresh
            if (existingWindow) {
                existingWindow.close();
            }

            // Open the new window, named so we can find it again
            var newWindow = window.open(data.url, windowName);
            if (newWindow == null) {
                // If a new window wasn't created, it's likely a popup blocker so notify the user
                eventBanner.addErrorMessages("Your browser prevented the window from opening. Check your pop-up blocker settings and allow pop-ups from this site.");
            }
            else {
                eventBanner.addInformationalMessages(`You have now been logged in to ${data.siteName} as ${data.subjectName} in a new tab or window.`)
            }

            // navigation was handled
            return true;
        }

        // Exported public API
        var exports = {
            navigate: navigate
        };

        return exports;
    }
);